export const FORMAT_DISTANCE_BASE_OPTIONS = {
  style: 'unit',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
} as const;

export const METERS_TO_FEET = 3.28084; // feet
export const KILOMETERS_TO_METERS = 1000; // meters
export const MILES_TO_METERS = 1609.344; // meters

export const SCALE_MAX_WIDTH = 100; // px
